import { getToken } from "./service";
import axios from "axios";
import qs from "qs";
import Config from "../config";
import { SourceItem } from "../pages/ResourcePool/service";
import { evaluationStatus } from "./evaluate";
import { cloneDeep } from "lodash-es";
import _ from "underscore";
import Storage from "../utils/Storage";
export interface CoursePlanWeek {
    weekTime: string;
    week: string;
    section: string;
    continunity: string;
    weekTimeId: string;
}

export enum HaveWeekTime {
    no = 0
}

export interface getCourseInfo {
    courseNo: string;
    courseSeq: string;
    batchNo: string;
}
/**
 * 查看网络课信息
 */
export function getCourseInfo(data: getCourseInfo) {
    return axios
        .post<SuccessData<SourceItem>>(
            `/teacher/coursewareSource/getCourseInfo`,
            data
        )
        .then(res => res.data.data);
}

/**
 * 当日课程关闭直播（备课直播滑块关）
 */
export function getCoursePlanWeek(params: {
    courseNo: string;
    courseSeq: string;
}) {
    const token = getToken();
    return axios
        .get<SuccessData<CoursePlanWeek[]>>(
            `teacher/coursePlan/getCoursePlanWeek?${qs.stringify(params)}`,
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export enum CourseWareType {
    Regular = "0", // 普通文档
    Video = "1" // 视频
}

export interface CourseWare {
    id: number;
    metaId: string;
    sort: string;
    readAuth: string;
    createTime: string;
    fileSize: number;
    fileName: string;
    fileType: string;
    useType: CourseWareType;
    fileId: string; // 文件存储名或VID
    url: string;
}

/**
 * 显示当前节的课件列表
 */
export function getCurrentCourseWareList(weekTimeId: number) {
    const token = getToken();
    return axios
        .get<SuccessData<CourseWare[]>>(
            `/teacher/courseware/getCurrentCourseWareList?weekTimeId=${weekTimeId}`,
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 删除课件
 */
export function removeCourseWare(fileCourseWareWeekTimeId: number) {
    const token = getToken();
    return axios.get<SuccessData<CourseWare[]>>(
        `/teacher/courseware/removeCourseWare?fileCourseWareWeekTimeId=${fileCourseWareWeekTimeId}`,
        { headers: { token } }
    );
}

/**
 * 下载课件
 * @param fileMetaId
 */
export function downloadCourseWare(fileMetaId: string) {
    const token = getToken();
    window.open(
        `${
            Config.ApiHost
        }teacher/courseware/downloadCourseWare?fileMetaId=${fileMetaId}&token=${encodeURIComponent(
            token!
        )}`
    );
}

export interface FileItem {
    metaId: string;
    sort: string;
    readAuth: string;
    createTime: string;
    fileSize: number;
    fileName: string;
    fileType: string;
    courseName: string;
    courseNo: string;
    courseSeq: string;
    batchNo: string;
    useType: CourseWareType;
    fileId: string; // 文件存储名或VID
    url: string;
}

/**
 * 选择课件列表
 * @param weekTimeId
 */
export function getUploadFileList(weekTimeId: number) {
    const token = getToken();
    return axios
        .get<SuccessData<FileItem[]>>(
            `/teacher/courseware/getUploadFileList?weekTimeId=${weekTimeId}`,
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 选择课件
 */
export function changeInsertCourseWare(weekTimeId: number, metaIds: string[]) {
    const token = getToken();
    const params = qs.stringify({ weekTimeId, metaIds: metaIds.join(",") });
    return axios.post<SuccessData<FileItem[]>>(
        `/teacher/courseware/changeInsertCourseWare`,
        params,
        { headers: { token } }
    );
}

/**
 * 查看课件信息
 */
export function getCourseWareInfo(id: number) {
    return axios
        .post<SuccessData<SourceItem>>(`/teacher/chapter/getSourceDetail`, {
            id
        })
        .then(res => res.data.data);
}

export interface TeacherCourse {
    courseName: string;
    batchNo: string;
    lmsCourseName: string;
    teacherName: string;
    courseNo: string;
    lmsCourseNo: string;
    courseSeq: string;
    weekTimeId: string;
}

/**
 * 获取网络课列表 （非计划课程）
 */

export function getNetCourseList() {
    const token = getToken();
    return axios
        .post<SuccessData<TeacherCourse[]>>(
            `/teacher/queryNetCourseList`,
            {},
            { headers: { token } }
        )
        .then(res => res.data.data);
}

export interface NoWeekTimeCourse {
    batchNo: string;
    courseName: string;
    isCloud: string;
    courseNo: string;
    courseSeq: string;
    className: string;
    lmsCourseNo: string;
    weekTimeId: string;
    channelId: string;
    isOpen: string;
    teacherName: string;
    evaluationId: string;
    evaluationStatus: string; //那就1代表评教结束呗
    evaluationReadStatus: string; //1 已读
    evaluationList: {
        evaluationId: string;
        teacherNo: string;
        isDeputy: string;
        evaluationName: string;
        evaluationReadStatus: "1";
        status: evaluationStatus;
    }[];
}

/**
 * 获取计划课列表
 */
export function getNoWeekTimeCourseList(batchNo?: string) {
    const token = getToken();
    const DefaultBatchNo = Storage.get("batch") || Config.DefaultBatch;

    return axios
        .post<SuccessData<NoWeekTimeCourse[]>>(
            `/teacher/queryNoWeekTimeCourseList`,
            qs.stringify({ batchNo: batchNo ?? DefaultBatchNo }),
            { headers: { token } }
        )
        .then(res => res.data.data ?? []);
}

export interface VideoListItem {
    batchNo: string;
    courseNo: string;
    courseSeq: string;
    fileName: string; // 文件名称
    num: number; // 文件数量
    tripleScreenDisplayNum: number; // 三分屏数量
    screenPlaybackNum: number; // 屏幕共享数量
    vodType?: string;
}

export interface VideoListItemPart {
    batchNo: string;
    courseNo: string;
    courseSeq: string;
}

interface QueryVideoList {
    groupByType: number;
    batchNo: string;
    courseNo: string;
    courseSeq: string;
}

/**
 * 视频下载列表
 */
export function videoList(query: QueryVideoList) {
    const params = cloneDeep(query);

    if (params.groupByType === 1) {
        params.batchNo = "";
        params.courseNo = "";
        params.courseSeq = "";
    }

    if (params.groupByType === 2) {
        params.courseNo = "";
        params.courseSeq = "";
    }

    return axios
        .post<SuccessData<VideoListItem[]>>(
            "/teacher/polyv/videoList",
            qs.stringify(params)
        )
        .then(res => res.data.data);
}

export async function downloadVideoUseThunder(
    downType: number,
    query: QueryVideoList
) {
    const params = _.pick(query, ["batchNo", "courseNo", "courseSeq"]);

    if (query.groupByType === 1) {
        params.courseNo = "";
        params.courseSeq = "";
    }

    const tasks = await axios
        .post<SuccessData<{ url: string; vodName: string }[]>>(
            "/teacher/polyv/downloadVideo",
            qs.stringify({ downType, ...params })
        )
        .then(res =>
            res.data.data.map(item => ({
                url: item.url,
                name: item.vodName + ".mp4",
                dir: "课件打包下载"
            }))
        );

    window.thunderLink.newTask({
        tasks
    });
}
